define([
    "./microstrategyModule"
], function (microstrategy) {
    "use strict";
    microstrategy.provider("microstrategyServiceUrl", [function () {

        var microstrategyLibraryIdentifier;
        var loginUrl;
        var logoutUrl;
        var configurationUrl;
        var isAllowedUrl;
        var renewSessionUrl;
        var homeState;
        this.setUrl = function (url) {
            microstrategyLibraryIdentifier = url.microstrategyLibraryIdentifier;
            loginUrl = url.loginUrl;
            logoutUrl = url.logoutUrl;
            configurationUrl = url.configurationUrl;
            isAllowedUrl = url.isAllowedUrl;
            renewSessionUrl = url.renewSessionUrl;
            homeState = url.homeState;
        };

        this.$get = [function () {
            return {
                microstrategyLibraryIdentifier: microstrategyLibraryIdentifier,
                loginUrl: loginUrl,
                logoutUrl: logoutUrl,
                configurationUrl: configurationUrl,
                isAllowedUrl: isAllowedUrl,
                renewSessionUrl: renewSessionUrl,
                homeState: homeState
            };
        }];
    }]);
});

